import { render, staticRenderFns } from "./BbvaQuotationF2.vue?vue&type=template&id=0c90ce3a"
import script from "./BbvaQuotationF2.vue?vue&type=script&lang=js"
export * from "./BbvaQuotationF2.vue?vue&type=script&lang=js"
import style0 from "./BbvaQuotationF2.vue?vue&type=style&index=0&id=0c90ce3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports